import "react";
import { Image } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Files/shared/LogoImage.tsx
function LogoImage({ maxHeight, maxWidth, url }) {
	if (!url) return null;
	return /* @__PURE__ */ jsx("div", {
		className: "relative",
		style: {
			minHeight: "100px",
			minWidth: "100px"
		},
		children: /* @__PURE__ */ jsx(Image, {
			alt: "",
			src: url,
			maxHeight: maxHeight || 100,
			maxWidth: maxWidth || 300
		})
	});
}
//#endregion
export { LogoImage };

//# sourceMappingURL=LogoImage.js.map